// SPDX-License-Identifier: AGPL-3.0-or-later

import DeveloperOptions from '@app/features/devtools/state/DeveloperOptions';

export function shouldShowPremiumFeatures(): boolean {
	return !DeveloperOptions.selfHostedModeOverride;
}
